module.exports = __webpack_public_path__ + "LatoLatin-Medium.fe06e5d5fbc7f65b83a2.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/LatoLatin/fonts/LatoLatin-Medium.ttf
// module id = ../../../../../src/assets/fonts/LatoLatin/fonts/LatoLatin-Medium.ttf
// module chunks = styles